import { ApiService } from '../Services/APIService';
import { ENDPOINTS } from '../Utils/APIConstants';
import { StorageUtils } from "../Utils/StorageUtils";

export const SubscriptionService = {
  
  /**
   * Get the current user's subscription status (starter/pro)
   * Returns: { userStatus, subscriptionStatus, currentPeriodEnd, cancelAtPeriodEnd, lastUpdated }
   */
  getUserStatus: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.get(ENDPOINTS.SUBSCRIPTION_STATUS);
  },

  /**
   * Fetch user's current subscription status from server (legacy method - kept for compatibility)
   */
  fetchSubscriptionStatus: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.get(ENDPOINTS.SUBSCRIPTION_STATUS);
  },

  /**
   * Update user's subscription status on server
   * @param {string} status - 'starter' or 'pro'
   */
  updateSubscriptionStatus: async (status) => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.put(ENDPOINTS.SUBSCRIPTION_STATUS, { status });
  },

  /**
   * Get detailed subscription information including plan details
   * Returns: { userStatus, subscriptionStatus, currentPeriodStart, currentPeriodEnd, priceInfo, stripeData }
   */
  getSubscriptionDetails: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.get(ENDPOINTS.SUBSCRIPTION_DETAILS);
  },

  /**
   * Get user profile including subscription data
   * Alternative endpoint that returns subscription info via user profile
   */
  getUserProfileWithSubscription: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.get('user/subscription');
  },

  /**
   * Sync subscription status from Stripe (useful for troubleshooting)
   * Forces a refresh of subscription data from Stripe
   */
  syncSubscriptionFromStripe: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.post(ENDPOINTS.SUBSCRIPTION_SYNC, {});
  },

  /**
   * Sync subscription status from Stripe (force refresh) - legacy method name
   */
  syncFromStripe: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.post(ENDPOINTS.SUBSCRIPTION_SYNC, {});
  },

  /**
   * Manually update user status (admin function)
   * @param {string} status - 'starter' or 'pro'
   */
  updateUserStatus: async (status) => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.put(ENDPOINTS.SUBSCRIPTION_STATUS, { status });
  }

};
